import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  FormText,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import axiosConfig from "consts/axiosConfig";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { registerRs } from "consts/Constants";

const schema = yup
  .object({
    name: yup.string().required(),
    price: yup.string().required(),
    entity_id: yup.string().required(),
    duration: yup.string().required(),
  })
  .required();
export default function AddEditPlanModal(props) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [loading, setLoading] = useState(false);
  const [entityType, setEntityType] = useState("organizations");
  const onSubmit = (data) => {
    var url = "admin/plans/store";
    if (props.currentModel?.id) {
      url = "admin/plans/update/" + props.currentModel.id;
    }
    data.entity_type = entityType;
    setLoading(true);
    axiosConfig
      .post(url, data)
      .then((res) => {
        if (!res.data.hasError) {
          props.toggleModal(false);
          props.setCurrenModel({});
          props.getItems();
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    reset(props?.currentModel);
  }, [props.currentModel, reset]);
  const createInputs = (
    name,
    label,
    placeHolder,
    type = "text",
    disabled = false
  ) => {
    return (
      <FormGroup>
        <label className="form-control-label" htmlFor={`input-${name}`}>
          {label}
        </label>
        <Input
          id={`input-${name}`}
          placeholder={placeHolder}
          type={type}
          disabled={loading || disabled}
          {...registerRs(name, register)}
        />
        <FormText color="danger">{errors[name]?.message}</FormText>
      </FormGroup>
    );
  };
  const renderEntities = () => {
    if (entityType === "users") {
      return props.userTypes.map((uT) => {
        return (
          <option key={uT.id} value={uT.id}>
            {uT.name}
          </option>
        );
      });
    } else {
      return props.orgTypes.map((uT) => {
        return (
          <option key={uT.id} value={uT.id}>
            {uT.name}
          </option>
        );
      });
    }
  };
  return (
    <Modal isOpen={props.showModal} size="lg">
      <ModalHeader>{props.title}</ModalHeader>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <Row>
            <Col lg={12}>{createInputs("name", "Plan Name", "Plan Name")}</Col>
            <Col lg={6}>
              <FormGroup>
                <label className="form-control-label" htmlFor={`input-start`}>
                  Duration
                </label>
                <Input
                  type="select"
                  disabled={loading}
                  {...registerRs("duration", register)}
                >
                  <option value="month">Monthly</option>
                  <option value="year">Yearly</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg={6}>
              {createInputs("price", "Price", "Price", "number")}
            </Col>
            <Col lg={6}>
              <FormGroup>
                <label className="form-control-label" htmlFor={`input-start`}>
                  Entity Type
                </label>
                <Input
                  type="select"
                  disabled={loading}
                  value={entityType}
                  onChange={(e) => setEntityType(e.target.value)}
                >
                  <option value="organizations">Organizations</option>
                  <option value="users">Users</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg={6}>
              <FormGroup>
                <label className="form-control-label" htmlFor={`input-start`}>
                  Entity Type
                </label>
                <Input
                  type="select"
                  disabled={loading}
                  {...registerRs("entity_id", register)}
                >
                  {renderEntities()}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        {loading ? (
          <ModalFooter>
            <div
              className="d-flex ai-center jc-center"
              style={{ width: "100%" }}
            >
              <Spinner animation="border" />
            </div>
          </ModalFooter>
        ) : (
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                props.setCurrenModel({});
                props.toggleModal(false);
              }}
            >
              Discard
            </Button>
            <Button disabled={loading} color="primary" type="submit">
              Save
            </Button>
          </ModalFooter>
        )}
      </Form>
    </Modal>
  );
}
